import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=bc34aa0c&scoped=true&"
import script from "./cookie.vue?vue&type=script&lang=js&"
export * from "./cookie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc34aa0c",
  null
  
)

export default component.exports